import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Typography } from '@redshelf/redshelf-ui';

import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      color: theme.palette.grey[900],
    },
  };
});

const HeaderSectionTitle = ({ children, className, ...props }) => {
  const classes = useStyles();

  return (
    <Typography
      component="h1"
      variant="h2"
      className={clsx(classes.root, className)}
      {...props}
    >
      {children}
    </Typography>
  );
};

HeaderSectionTitle.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
};

HeaderSectionTitle.defaultProps = {};

export default HeaderSectionTitle;
